import { TextFieldController } from '@buildwise/libs/ui';
import { useFormContext } from 'react-hook-form';
import FieldWrapper from './FieldWrapper';
import { EditProfileFormSchema } from '../../hooks/useProfileForm';

function ProfileDefaultFields() {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <>
      <FieldWrapper id="firstname" label="First Name" required disabled={isSubmitting}>
        <TextFieldController<EditProfileFormSchema>
          name="firstname"
          TextFieldProps={{ id: 'firstname', autoFocus: true }}
        />
      </FieldWrapper>

      <FieldWrapper id="lastname" label="Last Name" required disabled={isSubmitting}>
        <TextFieldController<EditProfileFormSchema>
          name="lastname"
          TextFieldProps={{ id: 'lastname' }}
        />
      </FieldWrapper>

      <FieldWrapper id="email" label="Email" required disabled={isSubmitting}>
        <TextFieldController<EditProfileFormSchema>
          name="email"
          TextFieldProps={{
            id: 'email',
            tabIndex: -1,
            disabled: true,
            InputProps: { readOnly: true },
          }}
        />
      </FieldWrapper>
    </>
  );
}

export default ProfileDefaultFields;
